module.exports = __webpack_public_path__ + "static/media/Fichier 14.b4e68858.svg";